import { tns } from 'tiny-slider';

export default class Sliders {
    static init(): void {
        this.aboutSlider();
        this.clubSlider();
        this.aboutDetailSlider();
        this.gallerySlider();
    }

    static aboutSlider(): void {
        const aboutSliderInit = document.querySelectorAll('.js-about-slider-init');

        if (aboutSliderInit.length === 0) return;

        aboutSliderInit.forEach((item) => {
            // Kontrola zda je item validní HTML element
            if (!item || !(item instanceof HTMLElement)) return;

            const sliderContainer = item.querySelector('.about-slider__inner');
            const sliderControls = item.querySelector('.about-slider__controls');

            // Přidána explicitní kontrola existence obou elementů
            if (!sliderContainer || !sliderControls) return;

            try {
                tns({
                    container: sliderContainer,
                    items: 1.25,
                    slideBy: 1,
                    nav: false,
                    controls: true,
                    controlsContainer: sliderControls,
                    gutter: 16,
                    loop: false,
                    mouseDrag: true,
                    preventScrollOnTouch: 'auto',
                    swipeAngle: 30,
                    responsive: {
                        768: {
                            items: 2.2222,
                        },
                        992: {
                            items: 3.3333,
                        },
                    },
                });
            } catch (error) {
                //console.error('Chyba při inicializaci product slideru:', error);
            }
        });
    }

    static gallerySlider(): void {
        const gallerySliderInit = document.querySelectorAll('.js-gallery-slider-init');

        if (gallerySliderInit.length === 0) return;

        gallerySliderInit.forEach((item) => {
            // Kontrola zda je item validní HTML element
            if (!item || !(item instanceof HTMLElement)) return;

            const sliderContainer = item.querySelector('.gallery-slider__inner');
            const sliderControls = item.querySelector('.gallery-slider__controls');

            // Přidána explicitní kontrola existence obou elementů
            if (!sliderContainer || !sliderControls) return;

            try {
                tns({
                    container: sliderContainer,
                    autoWidth: true,
                    items: 1.25,
                    slideBy: 1,
                    nav: false,
                    controls: true,
                    controlsContainer: sliderControls,
                    gutter: 16,
                    loop: false,
                    mouseDrag: true,
                    preventScrollOnTouch: 'auto',
                    swipeAngle: 30,
                    responsive: {
                        768: {
                            items: 2.2222,
                        },
                        992: {
                            items: 3.3333,
                        },
                    },
                });
            } catch (error) {
                //console.error('Chyba při inicializaci product slideru:', error);
            }
        });
    }

    static aboutDetailSlider(): void {
        const aboutSliderInit = document.querySelectorAll('.js-about-slider-detail-init');

        if (aboutSliderInit.length === 0) return;

        aboutSliderInit.forEach((item) => {
            // Kontrola zda je item validní HTML element
            if (!item || !(item instanceof HTMLElement)) return;

            const sliderContainer = item.querySelector('.about-slider__inner');
            const sliderControls = item.querySelector('.about-slider__controls');

            // Přidána explicitní kontrola existence obou elementů
            if (!sliderContainer || !sliderControls) return;

            try {
                tns({
                    container: sliderContainer,
                    items: 1.25,
                    slideBy: 1,
                    nav: false,
                    controls: true,
                    controlsContainer: sliderControls,
                    gutter: 16,
                    loop: false,
                    mouseDrag: true,
                    preventScrollOnTouch: 'auto',
                    swipeAngle: 30,
                    responsive: {
                        768: {
                            items: 2,
                        },
                        992: {
                            items: 4,
                        },
                    },
                });
            } catch (error) {
                //console.error('Chyba při inicializaci product slideru:', error);
            }
        });
    }

    static clubSlider(): void {
        const clubSliderInit = document.querySelectorAll('.js-club-slider-init');

        if (clubSliderInit.length === 0) return;

        clubSliderInit.forEach((item) => {
            // Kontrola zda je item validní HTML element
            if (!item || !(item instanceof HTMLElement)) return;

            const sliderContainer = item.querySelector('.club-slider__inner');
            const sliderControls = item.querySelector('.club-slider__controls');

            // Přidána explicitní kontrola existence obou elementů
            if (!sliderContainer || !sliderControls) return;

            try {
                tns({
                    container: sliderContainer,
                    items: 2,
                    slideBy: 1,
                    nav: false,
                    controls: true,
                    controlsContainer: sliderControls,
                    gutter: 16,
                    loop: false,
                    mouseDrag: true,
                    preventScrollOnTouch: 'auto',
                    swipeAngle: 30,
                    responsive: {
                        768: {
                            items: 3,
                        },
                        992: {
                            items: 5,
                        },
                        1200: {
                            items: 6,
                        },
                    },
                });
            } catch (error) {
                //console.error('Chyba při inicializaci product slideru:', error);
            }
        });
    }
}
